module.exports = __webpack_public_path__ + "assets/img/delete_outline_24px.1aca195d.svg";